module.exports = "<h1 class=\"title text-center\"> Angular Tutorial </h1>\n<div class=\"main\">\n\t<router-outlet></router-outlet>\n</div>\n"